import { render } from "./IndexContrat.vue?vue&type=template&id=6afdda80"
import script from "./IndexContrat.vue?vue&type=script&lang=js"
export * from "./IndexContrat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__